import React from 'react';
import AboutValues from '../components/AboutValues';
import VissionAndMession from '../components/VissionAndMession';
import { useTranslation } from 'react-i18next';



const About = () => {
      const { t, i18n } = useTranslation();

  return (
    <section className="py-24 relative bg-gray-50">
      <div className="w-full max-w-7xl px-4 md:px-5 lg:px-5 mx-auto">
        <VissionAndMession />
        {/* <AboutValues /> */}

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-20">
          {/* Vision Section */}
          <div className="bg-gray-50 p-6 rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300">
            <h2 className="text-3xl font-semibold text-gray-800 border-b-2 border-indigo-500 pb-2">
              {t("vision-title")}
            </h2>
            <p className="mt-4 text-lg text-gray-700 leading-relaxed">
              {t("vision")}
            </p>
          </div>

          {/* Mission Section */}
          <div className="bg-gray-50 p-6 rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300">
            <h2 className="text-3xl font-semibold text-gray-800 border-b-2 border-indigo-500 pb-2">
              {t("mission-title")}
            </h2>
            <p className="mt-4 text-lg text-gray-700 leading-relaxed">
              {t("mission")}
            </p>
          </div>

          {/* Objectives Section */}
          <div className="bg-gray-50 p-6 rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300">
            <h2 className="text-3xl font-semibold text-gray-800 border-b-2 border-indigo-500 pb-2">
              {t("about-us-introduction-to-help-objectives")}
            </h2>
            <ul className="mt-4 list-disc list-inside space-y-2 text-lg text-gray-700">
              <li>{t("about-us-introduction-to-help-objectives-item-1")}</li>
              <li>{t("about-us-introduction-to-help-objectives-item-2")}</li>
              <li>{t("about-us-introduction-to-help-objectives-item-3")}</li>
              <li>{t("about-us-introduction-to-help-objectives-item-4")}</li>
              <li>{t("about-us-introduction-to-help-objectives-item-5")}</li>
            </ul>
          </div>

          {/* Key Features Section */}
          <div className="bg-gray-50 p-6 rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300">
            <h2 className="text-3xl font-semibold text-gray-800 border-b-2 border-indigo-500 pb-2">
              {t("about-us-key-features")}
            </h2>
            <ul className="mt-4 list-disc list-inside space-y-2 text-lg text-gray-700">
              <li>{t("about-us-key-features-item-1")}</li>
              <li>{t("about-us-key-features-item-2")}</li>
              <li>{t("about-us-key-features-item-3")}</li>
              <li>{t("about-us-key-features-item-4")}</li>
              <li>{t("about-us-key-features-item-5")}</li>
            </ul>
          </div>

          {/* Users Section */}
          <div className="bg-gray-50 p-6 rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300">
            <h2 className="text-3xl font-semibold text-gray-800 border-b-2 border-indigo-500 pb-2">
              {t("about-us-users")}
            </h2>
            <p className="mt-4 text-lg text-gray-700 leading-relaxed">
              {t("about-us-users-description")}
            </p>
          </div>
      </div>

      </div>
    </section>
  );
};

export default About;
